import { api } from '@/shared/lib/axios.ts';
import type {
  AvailabilityRow,
  MaintenanceReportRow,
  AuditReportRow,
  AuditFiltersResult,
  ProbeSummaryRow,
} from '@/shared/types/report.ts';

/* ── query param types ────────────────────────────────── */

export interface AvailabilityParams {
  month?: string;
  from?: string;
  to?: string;
  tenantId?: string;
}

export interface MaintenancesReportParams {
  from: string;
  to: string;
  tenantId?: string;
}

export interface AuditParams {
  from: string;
  to: string;
  userId?: string;
  action?: string;
}

export interface ProbeSummaryParams {
  from: string;
  to: string;
  tenantId?: string;
}

/* ── available months ─────────────────────────────────── */

export async function getAvailableMonths(): Promise<string[]> {
  const { data } = await api.get<string[]>('/admin/reports/available-months');
  return data;
}

/* ── data fetchers ────────────────────────────────────── */

export async function getAvailability(params: AvailabilityParams): Promise<AvailabilityRow[]> {
  const { data } = await api.get<AvailabilityRow[]>('/admin/reports/availability', { params });
  return data;
}

export async function getMaintenancesReport(params: MaintenancesReportParams): Promise<MaintenanceReportRow[]> {
  const { data } = await api.get<MaintenanceReportRow[]>('/admin/reports/maintenances', { params });
  return data;
}

export async function getAuditReport(params: AuditParams): Promise<AuditReportRow[]> {
  const { data } = await api.get<AuditReportRow[]>('/admin/reports/audit', { params });
  return data;
}

export async function getAuditFilters(): Promise<AuditFiltersResult> {
  const { data } = await api.get<AuditFiltersResult>('/admin/reports/audit/filters');
  return data;
}

export async function getProbeSummary(params: ProbeSummaryParams): Promise<ProbeSummaryRow[]> {
  const { data } = await api.get<ProbeSummaryRow[]>('/admin/reports/probe-summary', { params });
  return data;
}
